import { httpDelete, httpGet, httpPost, httpPostFile, httpPut } from "./http";
import { rppAuthScope } from "./authenticationUtils.ts";

export const apiConfigGet = async <T>(url: string): Promise<T> => {
    return httpGet(getFullUrl(url), [rppAuthScope]);
}

export const apiConfigPost = async <T, Model>(url: string, model: Model): Promise<T> => {
    return httpPost(getFullUrl(url), model, [rppAuthScope]);
}

export const apiConfigPut = async <T, Model>(url: string, model: Model): Promise<T> => {
    return httpPut(getFullUrl(url), model, [rppAuthScope]);
}

export const apiConfigDelete = async <T>(url: string): Promise<T> => {
    return httpDelete(getFullUrl(url), [rppAuthScope]);
}

export const apiConfigPostFile = async <T, Model>(
    url: string, model: Model, progressUpdated?: (perc: number) => void
): Promise<T> => {
    return httpPostFile(getFullUrl(url), model, progressUpdated, [rppAuthScope]);
}

export const getFullUrl = (url: string): string => {
    return `${globalThis.config.api_config_url}/${url}`;
};
